import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";

const barChartFunc = (divRef, ndx) => {
    const myChart = dc.rowChart(divRef);
    const dimension = ndx.dimension(function (d) {
      return d.s_level;
    });
     const group = dimension.group().reduce(
      function(p, v) { // add
        ++p.count;
        if(p.count > 0) {
          p.total += Math.floor(parseFloat(v.wait_time));
          p.avg = Math.floor(parseFloat(100*p.total/p.count))/100;
          p.tot_conversation_time +=  Math.floor(parseFloat(v.conversation_time));
          p.avg_conversation_time =  Math.floor(parseFloat(100*p.tot_conversation_time/p.count))/100;
        }
        else {
          p.avg = 0;
          p.total = 0;
          p.tot_conversation_time = 0;
          p.avg_conversation_time = 0;
        }
        return p;
    },
    function(p, v) { // remove
      --p.count;
      if(p.count > 0) {
        p.total -= Math.floor(parseFloat(v.wait_time));
        p.avg = Math.floor(parseFloat(100*p.total/p.count))/100;
        p.tot_conversation_time -=  Math.floor(parseFloat(v.conversation_time));
        p.avg_conversation_time =  Math.floor(parseFloat(100*p.tot_conversation_time/p.count))/100;
      }
      else {
        p.avg = 0;
        p.total = 0;
        p.tot_conversation_time = 0;
        p.avg_conversation_time = 0;
      }
      return p;
    },
    function() { // init
        return {count: 0, total: 0, avg: 0, tot_conversation_time: 0, avg_conversation_time: 0};
    }
  );

  const size = group.size();
  const barHeight = 25;

    myChart
    .dimension(dimension)
    .group(group)
    .valueAccessor(function (p) {
       return p.value.count ;
     })
    //.ordering(function(d){ return d.value})
    .elasticX(true)
    //.elasticY(true)
    .margins({ top: 5, right: 15, bottom: 25, left: 100 })
    .labelOffsetX(-100)
    .height(30 + size*(barHeight+5))
    .ordinalColors([ "rgb(49, 130, 189)"])
    .transitionDuration(1000)
    //.renderTitleLabel(true)
    .fixedBarHeight(barHeight)
    .xAxis().ticks(6)

    return myChart
}

export class SLevelChart extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ChartTemplate chartFunction={barChartFunc} title={this.props.title}
        dim={this.props.dim} type={this.props.type}/>
    );
  }
}
